// extracted by mini-css-extract-plugin
module.exports = {"container":"News_container__1Q0qy","sheet":"News_sheet__w407K","active":"News_active__1Fdws","margin":"News_margin__2PpCe"};